module.exports = __webpack_public_path__ + "static/media/trainingObedienceIcon.8db3a26c.png";